<h2 mat-dialog-title>
  {{ 'Locate Address' | translate }}
</h2>
<mat-dialog-content class="locate-address-dialog">
  <mat-form-field class="locate-address-dialog__field" appearance="fill">
    <mat-label>{{ 'Address' | translate }}</mat-label>
    <input matInput [(ngModel)]="address" [maxlength]="500" (keydown.enter)="confirm()" />
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="green-text" mat-raised-button (click)="confirm()">{{ 'Search' | translate }}</button>
  <button class="red-text" mat-raised-button mat-dialog-close>
    {{ "Cancel" | translate }}
  </button>
</mat-dialog-actions>